import { IconCheckCircle } from "../icon/variants/IconCheckCircle.js";
import { IconError } from "../icon/variants/IconError.js";
import { IconInfo } from "../icon/variants/IconInfo.js";
import { IconSavings } from "../icon/variants/IconSavings.js";
import { IconWarning } from "../icon/variants/IconWarning.js";
import { Flex as Flex$1, ThemeIcon } from "../mantine-passthroughs/index.js";
import { Body1 } from "../typography/Body1.js";
import { TextButton } from "../button/TextButton.js";
import alert_module_default from "./alert.module.js";
import { Alert } from "@mantine/core";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/components/alert/Alert.tsx
const ALERT_ICON_VARIANT = {
	default: "default",
	circle: "circle"
};
const severityIcons = {
	gray: IconInfo,
	saving: IconSavings,
	primary: IconInfo,
	secondary: IconInfo,
	error: IconError,
	success: IconCheckCircle,
	warning: IconWarning,
	info: IconInfo,
	notice: IconInfo
};
const Alert$1 = ({ children, dataTestId, "data-testid": testId = dataTestId ?? "alert", IconOverride = void 0, severity, primaryButtonProps, secondaryButtonProps, radius = "none", iconVariant = ALERT_ICON_VARIANT.default }) => {
	const Icon = IconOverride === void 0 ? severityIcons[severity] : IconOverride;
	const contents = typeof children === "string" ? /* @__PURE__ */ jsx(Body1, { children }) : children;
	let icon = null;
	if (Icon) icon = iconVariant === ALERT_ICON_VARIANT.circle ? /* @__PURE__ */ jsx(ThemeIcon, {
		radius: "xl",
		size: "lg",
		variant: "white",
		children: /* @__PURE__ */ jsx(Icon, { color: severity })
	}) : /* @__PURE__ */ jsx(Icon, {});
	return /* @__PURE__ */ jsxs(Alert, {
		"data-testid": testId,
		classNames: alert_module_default,
		variant: "light",
		color: severity,
		radius,
		icon,
		"data-icon-variant": iconVariant,
		children: [contents, primaryButtonProps?.label && /* @__PURE__ */ jsxs(Flex$1, {
			gap: "sm",
			justify: "flex-end",
			children: [/* @__PURE__ */ jsx(TextButton, {
				onClick: primaryButtonProps.action,
				color: severity,
				children: primaryButtonProps.label
			}), secondaryButtonProps?.label && /* @__PURE__ */ jsx(TextButton, {
				onClick: secondaryButtonProps.action,
				color: severity,
				children: secondaryButtonProps.label
			})]
		})]
	});
};

//#endregion
export { ALERT_ICON_VARIANT, Alert$1 as Alert };